module.exports = __webpack_public_path__ + "img/award-btn-claimed.306b9397.png";